<script>
  import { _ } from "../../stores/index"
  import { ConfirmModal, APIKeyModal } from "../../components/index"
  import { FlexItem, Flex, Button, Icon, Text, Tag } from "@gl/design-system"
  import { isAfter, format } from "date-fns"
  import { faTrashAlt, faPlus } from "@fortawesome/pro-regular-svg-icons"
  import { UsersRepository } from "../../repositories/index"
  import { onMount, getContext } from "svelte"
  export let id
  const { isAuthorized } = getContext("isAuthorized")

  const loading = {}

  let confirmModal
  let keyModal
  let modalType
  let selectedToken

  let tokens

  async function fetchTokens() {
    try {
      loading.tokens = true
      const result = await UsersRepository.getUserTokens(id)
      tokens = result.list
    } catch (error) {
      loading.tokens = false
    }
  }

  async function removeKey() {
    try {
      loading.remove = true
      await UsersRepository.deleteToken(id, selectedToken)
    } finally {
      loading.remove = false
      fetchTokens()
    }
  }

  onMount(() => {
    fetchTokens()
  })
</script>

{#if confirmModal}
  <ConfirmModal
    bind:active={confirmModal}
    on:close={() => {
      confirmModal = false
    }}
    handleYes={removeKey}
    title={$_("users.delete.key")}
  >
    <p class="mb-2">{$_("users.delete.key.confirm")}</p>
  </ConfirmModal>
{/if}

{#if keyModal}
  <APIKeyModal
    {modalType}
    userId={id}
    bind:active={keyModal}
    on:close={() => {
      keyModal = false
      fetchTokens()
    }}
  />
{/if}

{#if tokens}
  <Flex class="mt-6 mb-4">
    <FlexItem>
      <p>{$_("users.key.maximum")}</p>
    </FlexItem>

    <FlexItem pushEnd>
      <Flex>
        <FlexItem>
          {#if $isAuthorized("token_create")}
            <Button
              on:click={() => {
                modalType = "create"
                keyModal = true
              }}
              size="small"
              class="ml-3"
              loading={loading.add}
              disabled={tokens.length >= 3}
            >
              <Icon icon={faPlus} />
              <Text>{$_("users.new.key")}</Text>
            </Button>
          {/if}
        </FlexItem>
      </Flex>
    </FlexItem>
  </Flex>
  {#if tokens.length === 0}
    <div class="w-100 user-main-card my-4 p-4">
      <p>{$_("users.no.key")}</p>
    </div>
  {:else}
    {#each tokens as token}
      {@const tokenExpired = isAfter(new Date(), new Date(token.expiration))}
      <div class="w-100 user-main-card my-4">
        <div class="user-row" id="api-name">
          <div class="user-title">{$_("common.name")}</div>
          <div class="user-td" class:expired={tokenExpired}>
            <b>{token.name}</b>
          </div>
          <div class="action-buttons">
            {#if $isAuthorized("token_delete")}
              <Button
                status="error"
                on:click={() => {
                  confirmModal = true
                  selectedToken = token.id
                }}
                size="small"
                outlined
                loading={loading.remove}
              >
                <Icon icon={faTrashAlt} />
                <Text>{$_("buttons.delete")}</Text>
              </Button>
            {/if}
          </div>
        </div>

        <div class="user-row" id="api-state">
          <div class="user-title">
            {$_("common.status")}
          </div>
          <div class="user-td" class:expired={tokenExpired}>
            <Tag status={tokenExpired ? "default" : "success"}>
              {tokenExpired ? $_("users.key.expired") : $_("users.key.active")}
            </Tag>
          </div>
        </div>
        <div class="user-row" id="api-expire-date">
          <div class="user-title">{$_("users.key.expire")}</div>
          <div class="user-td" class:expired={tokenExpired}>
            {#if token.expiration === new Date(8640000000000000).toISOString()}
              -
            {:else}
              {format(new Date(token.expiration), "dd.MM.yyyy")}
            {/if}
          </div>
        </div>
        <div class="user-row" id="api-created">
          <div class="user-title">{$_("common.created")}</div>
          <div class="user-td" class:expired={tokenExpired}>
            {format(new Date(token.createdAt), "dd.MM.yyyy")}
          </div>
        </div>
        <div class="user-row" id="api-created-by">
          <div class="user-title">{$_("common.created.by")}</div>
          <div class="user-td" class:expired={tokenExpired}>
            {token.createdBy}
          </div>
        </div>
      </div>
    {/each}
  {/if}
{/if}

<style>
  .expired {
    color: #bfbfbf;
  }

  .expired :global(span) {
    color: #bfbfbf;
  }

  .action-buttons {
    display: flex;
    width: 100%;
    justify-content: end;
  }

  .user-row {
    align-items: center;
  }
</style>
